import React, { useEffect, useState } from "react";
import Pagination from "react-js-pagination";
import ConfigDB from "../../config";

import {
  createPartType,
  deletePartType,
  getPartType,
  importPartType,
  updatePartType,
  getExportPartType,
} from "../../services/PartTypeService";
import { toast } from "react-toastify";
import Utils from "../../utils";
import {
  Button,
  Form,
  FormGroup,
  Label,
  Modal,
  ModalBody,
  ModalFooter,
  ModalHeader,
} from "reactstrap";
import * as XLSX from "xlsx";
import { useLocation, useNavigate } from "react-router-dom";
import Dropdown from "react-bootstrap/Dropdown";
import { useTranslation } from "react-i18next";
import ReactPaginate from "react-paginate";
import {
  getReservesPartPendingList,
  getwarHouseEntityList,
} from "../../services/PartsInventory";
import {
  createAssignResPart,
  updateAssignResPart,
} from "../../services/ClientProfileServices";

const ReservesPendingList = ({
  reserveData,
  setStep,
  partIdData,
  reserveDetails,
}) => {
  const location = useLocation();
  const RolePermission = Utils.getRecordForCurrentPath(location);
  const tableLengthList = ConfigDB.data.dataTableLength;
  const data = localStorage.getItem(ConfigDB.data.login_data);
  const companyId = JSON.parse(data);
  const { t } = useTranslation();
  const navigate = useNavigate();

  const [params, setParams] = useState({
    limit: tableLengthList[0],
    page: 1,
    search: "",
    is_reload: false,
    company_id: companyId.company_id || 0,
  });
  const [totalRecords, setTotalRecords] = useState(0);

  const [reservesPenList, setReservesPenList] = useState([]);

  const [modifyqtyModal, setmodifyqtyModal] = useState(false);
  const [partqtyDetails, setPartqtyDetails] = useState("");
  const [selectedParts, setSelectedParts] = useState([]);

  const [unselectedParts, setUnselectedParts] = useState([]);

  const [resOrderData, setResOrderData] = useState({
    reservation_order_notes: "",
  });
  const [selectedPrices, setSelectedPrices] = useState({});
  const [selectedEntities, setSelectedEntities] = useState({});
  const [entityList, setEntityList] = useState([]);
  const [searchText, setSearchText] = useState("");
  const [previousSearch, setPreviousSearch] = useState("");

  const handleSelectChange = (event, item) => {
    const value = event.target.value;

    setSelectedEntities((prevState) => ({
      ...prevState,
      [item.id]: value,
    }));
  };
  useEffect(() => {
    let data = { ...params };
    getwarHouseEntityList(data)
      .then((response) => {
        setEntityList(response.data.data);
      })
      .catch((err) => {
        toast.error(err.message);
      });
  }, [params]);

  const handleManualInput = (partId, value) => {
    setSelectedPrices((prev) => ({
      ...prev,
      [partId]: value,
    }));
  };

  const handleCheckboxChange = (partId, id) => {
    setSelectedParts((prevSelected) => {
      const isAlreadySelected = prevSelected.some((item) => item.id === id);

      if (isAlreadySelected) {
        const updatedSelected = prevSelected.filter((item) => item.id !== id);

        const uncheckedParts = partqtyDetails?.reserve_order_list.filter(
          (reservePart) =>
            Number(reservePart.reservation_id) === Number(reserveDetails.id) &&
            Number(reservePart.part_qty_label_id) === Number(id)
        );

        setUnselectedParts((prevUnselected) => [
          ...prevUnselected,
          ...uncheckedParts,
        ]);

        return updatedSelected;
      } else {
        setUnselectedParts((prevUnselected) =>
          prevUnselected.filter(
            (item) => Number(item.part_qty_label_id) !== Number(id)
          )
        );

        return [...prevSelected, { parts_id: partId, id }];
      }
    });
  };

  const handleQtyOpen = (e, item) => {
    setPartqtyDetails(item);
    setmodifyqtyModal(true);
  };

  const handleQtyClose = () => {
    setmodifyqtyModal(false);
  };

  useEffect(() => {
    if (Array.isArray(reservesPenList) && reserveDetails?.id) {
      const matchingParts = reservesPenList.filter((item) =>
        item.reserve_order_list?.some(
          (r) => Number(r.reservation_id) === Number(reserveDetails.id)
        )
      );

      if (matchingParts.length > 0) {
        setPartqtyDetails(matchingParts);

        const preSelectedParts = [];
        const preSelectedPrices = {};
        const preSelectedEntities = {};
        const preReservationNotes = {};

        matchingParts.forEach((part) => {
          part.reserve_order_list?.forEach((reserve) => {
            if (Number(reserve.reservation_id) !== Number(reserveDetails.id))
              return;

            const matchedPart = part.part_qty_list?.find(
              (p) => Number(p.id) === Number(reserve.part_qty_label_id)
            );

            if (matchedPart) {
              preSelectedParts.push(matchedPart);
              preSelectedPrices[matchedPart.id] = reserve.reserve_price;
              preSelectedEntities[matchedPart.id] = reserve.location_id;
              preReservationNotes[matchedPart.id] =
                reserve.reservation_order_notes || "";
            }
          });
        });

        setSelectedParts(preSelectedParts);
        setSelectedPrices(preSelectedPrices);
        setSelectedEntities(preSelectedEntities);
        setResOrderData((prev) => ({
          ...prev,
          reservation_order_notes: preReservationNotes,
        }));
      }
    }
  }, [reservesPenList, reserveDetails]);

  const handleQtyCloseFinal = () => {
    if (Object.keys(selectedPrices).length === 0) {
      toast.error(t("at_least_one_price_required"));
      return;
    }

    // if (Object.keys(selectedEntities).length === 0) {
    //   toast.error("At least one entity must be selected");
    //   return;
    // }

    if (!selectedParts || selectedParts.length === 0) {
      toast.error(t("at_least_one_quantity_required"));
      return;
    }

    setmodifyqtyModal(false);
  };

  useEffect(() => {
    const currentPath = location.pathname;
    const savedPath = localStorage.getItem("lastVisitedPath");

    if (savedPath && savedPath !== currentPath) {
      localStorage.removeItem("lastVisitedPage");
    }

    localStorage.setItem("lastVisitedPath", currentPath);

    const savedPage = localStorage.getItem("lastVisitedPage");
    if (savedPage) {
      setParams((prevParams) => ({
        ...prevParams,
        page: parseInt(savedPage, 10),
      }));
    }
  }, [location.pathname]);

  const handleParams = (e, type) => {
    let paramsObj = { ...params };
    if (type === "length") {
      paramsObj.limit = e.target.value;
    } else if (type === "search") {
      paramsObj.page = 1;
      paramsObj.search = e.target.value;
    } else if (type === "pagination") {
      paramsObj.page = e.selected + 1; // ReactPaginate starts from 0, so we add 1
      localStorage.setItem("lastVisitedPage", e.selected + 1); // Save the selected page to localStorage
    }
    setParams(paramsObj);
  };

  // useEffect(() => {
  //   if (
  //     partqtyDetails?.reserve_order_list?.length &&
  //     partqtyDetails?.part_qty_list?.length
  //   ) {
  //     const preSelectedParts = [];
  //     const preSelectedPrices = {};
  //     const preSelectedEntities = {};
  //     const preReservationNotes = {};

  //     partqtyDetails.reserve_order_list?.forEach((reservePart) => {
  //       if (Number(reservePart.reservation_id) !== Number(reserveDetails.id))
  //         return;

  //       const matchedPart = partqtyDetails?.part_qty_list.find(
  //         (part) => Number(part.id) === Number(reservePart.part_qty_label_id)
  //       );

  //       if (matchedPart) {
  //         preSelectedParts.push(matchedPart);

  //         preSelectedPrices[matchedPart.id] = reservePart.reserve_price;

  //         preSelectedEntities[matchedPart.id] = reservePart.location_id;

  //         preReservationNotes[matchedPart.id] =
  //           reservePart.reservation_order_notes || "";
  //       }
  //     });

  //     // setSelectedParts(preSelectedParts);
  //     // setSelectedPrices(preSelectedPrices);
  //     // setSelectedEntities(preSelectedEntities);
  //     // setResOrderData((prev) => ({
  //     //   ...prev,
  //     //   reservation_order_notes: preReservationNotes,
  //     // }));
  //   }
  // }, [reserveDetails, partqtyDetails]);

  const fetchPartLocation = () => {
    const partsId = partIdData?.map((x) => x?.id);

    let data = {
      parts_id: partsId,
      reservation_id: reserveDetails?.id ? reserveDetails?.id : "",
      limit: tableLengthList[0],
      page: 1,
      search: searchText,
      is_reload: false,
      company_id: companyId.company_id || 0,
      is_update: true,
    };
    getReservesPartPendingList(data)
      .then((response) => {
        setReservesPenList(response.data.data);

        setTotalRecords(response.data.total);
      })
      .catch((err) => {
        toast.dismiss();
        toast.error(Utils.getErrorMessage(err));
      });
  };

  useEffect(function () {
    const partsId = partIdData?.map((x) => x?.id);

    let data = {
      parts_id: partsId,
      limit: tableLengthList[0],
      page: 1,
      search: "",
      is_reload: false,
      company_id: companyId.company_id || 0,
    };

    fetchPartLocation(data);
  }, []);

  const renderOptions = (nodes, level = 0) => {
    return nodes?.map((node) => {
      if (node.children && node.children.length > 0) {
        return (
          <>
            <optgroup
              label={"\u00A0\u00A0".repeat(level) + node.warehouse_name}
              key={node.id}
            />
            {renderOptions(node.children, level + 1)}
          </>
        );
      } else {
        return (
          <option value={node.id} key={node.id}>
            {"\u00A0\u00A0".repeat(level) + node.warehouse_name}
          </option>
        );
      }
    });
  };

  const handleSubmit = (e) => {
    e.preventDefault();

    if (!selectedParts.length > 0) {
      toast.error("at least one quntity assign");
      return;
    }

    const allPricesSelected = selectedParts.every(
      (item) =>
        selectedPrices[item.id] !== undefined &&
        selectedPrices[item.id] !== null
    );

    if (!allPricesSelected) {
      toast.error(t("valid_price_required_all_parts"));
      return;
    }

    const partListData = [];

    selectedParts?.forEach((item) => {
      const partsId = item.parts_id;

      let partGroup = partListData.find((entry) => entry.parts_id === partsId);
      if (!partGroup) {
        partGroup = { parts_id: partsId, part_qty_list: [] };
        partListData.push(partGroup);
      }

      partGroup.part_qty_list.push({
        reserve_price: selectedPrices[item.id] ?? 0,
        reserve_vat_price: 0,
        part_qty_id: item.id,
        location_id: selectedEntities[item?.id],
        reservation_order_notes:
          resOrderData.reservation_order_notes[item.id] || "",
      });
    });

    const partListUncheckData = unselectedParts
      ?.flat()
      .map((x) => x?.part_qty_label_id);

    let data = {
      part_list: partListData,
      client_id: reserveData?.client_id,
      reservation_end_date: reserveData?.reservation_end_date,
      warehouses_id: reserveData.warehouses_id,
      users_id: reserveData?.users_id,
      shipping_price: reserveData?.shipping_price,
      packing_price: reserveData?.packing_price,
      parcel_price: reserveData?.parcel_price,
      reservation_notes: reserveData?.reservation_notes,
      send_email: reserveData?.send_email,
      send_whatsapp: reserveData?.send_whatsapp,
      reservation_end_alert: reserveData?.reservation_end_alert,
      reservation_name: reserveData?.reservation_name,
      name: reserveData?.name,
      country_code: reserveData?.country_code,
      district: reserveData?.district?.label
        ? reserveData?.district?.label
        : reserveData?.district,
      city: reserveData?.city?.label
        ? reserveData?.city?.label
        : reserveData?.city,
      bill_address: reserveData?.bill_address,
      postal_code: reserveData?.postal_code,
      shipping_addresses: reserveData?.shipping_addresses,
      vat_country_code: reserveData?.vat_country_code,
      vat_number: reserveData?.vat_number,
      vat_percentage: reserveData?.vat_percentage,
      is_vat_exempt: reserveData?.is_vat_exempt,
      indicative_phone_code: reserveData?.indicative_phone_code,
      phone_number: reserveData?.phone_number,
      whatsapp_number: reserveData?.whatsapp_number,
      email: reserveData?.email,
    };

    let updatedata = {
      uuid: reserveDetails?.uuid,
      part_list: partListData,
      uncheck_part_qty: partListUncheckData,
      client_id: reserveData?.client_id,
      reservation_end_date: reserveData?.reservation_end_date,
      warehouses_id: reserveData.warehouses_id,
      users_id: reserveData?.users_id,
      shipping_price: reserveData?.shipping_price,
      packing_price: reserveData?.packing_price,
      parcel_price: reserveData?.parcel_price,
      reservation_notes: reserveData?.reservation_notes,
      send_email: reserveData?.send_email,
      send_whatsapp: reserveData?.send_whatsapp,
      reservation_end_alert: reserveData?.reservation_end_alert,
      reservation_name: reserveData?.reservation_name,
      name: reserveData?.name,
      country_code: reserveData?.country_code,
      district: reserveData?.district?.label
        ? reserveData?.district?.label
        : reserveData?.district,
      city: reserveData?.city?.label
        ? reserveData?.city?.label
        : reserveData?.city,
      bill_address: reserveData?.bill_address,
      postal_code: reserveData?.postal_code,
      shipping_addresses: reserveData?.shipping_addresses,
      vat_country_code: reserveData?.vat_country_code,
      vat_number: reserveData?.vat_number,
      vat_percentage: reserveData?.vat_percentage,
      is_vat_exempt: reserveData?.is_vat_exempt,
      indicative_phone_code: reserveData?.indicative_phone_code,
      phone_number: reserveData?.phone_number,
      whatsapp_number: reserveData?.whatsapp_number,
      email: reserveData?.email,
    };

    if (reserveDetails?.uuid) {
      updateAssignResPart(updatedata)
        .then((response) => {
          toast.success(response.data.message);
          navigate("/show-reserves-list");
        })
        .catch((err) => {
          toast.error(Utils.getErrorMessage(err));
        });
    } else {
      createAssignResPart(data)
        .then((response) => {
          toast.success(response.data.message);
          navigate("/show-reserves-list");
        })
        .catch((err) => {
          toast.error(Utils.getErrorMessage(err));
        });
    }
  };

  return (
    <div>
      <div>
        <section className="content-header">
          <div className="container-fluid">
            <div className="row mb-2">
              <div className="col-sm-6"></div>
              <div className="col-sm-6"></div>
            </div>
          </div>
        </section>
        <section className="content">
          <div className="container-fluid container-custom-height-new ">
            <div className="row">
              <div className="col-md-12">
                <div className="card-header">
                  <div className="card-title m-0 float-left d-flex">
                    <button
                      type="button"
                      className="btn btn-block btn-primary"
                      onClick={() => setStep(2)}
                      style={{ width: "100px", marginTop: "10px" }}
                    >
                      {t("back")} <i className="bi bi-arrow-left-short"></i>
                    </button>
                  </div>
                  <div className="card-title m-0 float-right d-flex">
                    <button
                      type="Button"
                      className="btn btn-block btn-primary"
                      onClick={handleSubmit}
                      style={{ width: "100px", marginTop: "10px" }}
                    >{t("save")}<i className="bi bi-x-lg"></i>
                    </button>
                  </div>
                </div>
                <div className="card fuelCard">
                  <div className="card-header">
                    <div
                      className="card-title m-0 float-left"
                      style={{ width: "50%" }}
                    >
                      <input
                        type="text"
                        className="form-control"
                        placeholder={t("search")}
                        value={searchText}
                        onChange={(e) => {
                          setSearchText(e.target.value);
                        }}
                        onBlur={() => {
                          if (searchText !== previousSearch) {
                            setPreviousSearch(searchText); // Update the last searched term
                            fetchPartLocation(); // Call API
                          }
                        }}
                      />
                    </div>
                  </div>
                  <div className="card-body fuelCardB">
                    <div className="vehicleThBg table-responsive table-responsive-vehicle">
                      <table className="table table-bordered rounded-table table-striped table-hover">
                        <thead>
                          <tr>

                            <th
                              className="col-form-label ml-2 Label-my form-label form-label"
                              style={{ width: "10%" }}
                            >
                              Part
                            </th>

                            <th style={{ width: "1%" }}>Quantity</th>
                            <th style={{ width: "1%" }}>Reserved Quantity</th>

                            <th
                              className="col-form-label ml-2 Label-my form-label form-label"
                              style={{ textAlign: "center", width: "0%" }}
                            >
                              Asssign Quantity
                            </th>
                          </tr>
                        </thead>
                        <tbody>
                          {reservesPenList?.map((item, index) => (
                            <tr key={item.id}>
                              {" "}
                              <td>
                                {item.part_name} /{" "}
                                {(item?.vehicle_make_name || "") +
                                  " " +
                                  (item?.vehicle_model_name || "")}{" "}
                                / {item?.part_code} / {item?.parts_internal_id}
                              </td>
                              <td>{item?.quantity}</td>
                              <td>{item?.reserved_quantity}</td>
                              <td
                                style={{ cursor: "pointer" }}
                                onClick={(e) => handleQtyOpen(e, item)}
                              >
                                <i className="bi bi-clipboard-check"></i>
                              </td>
                            </tr>
                          ))}
                          {reservesPenList && reservesPenList.length === 0 && (
                            <tr>
                              <td colSpan={4} className="text-center">
                                Record Not Found
                              </td>
                            </tr>
                          )}
                        </tbody>
                      </table>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="card-footer card-footer-part clearfix">
            <div className="pagination pagination-sm m-0 float-right">
              <ReactPaginate
                previousLabel={<i className="bi bi-chevron-double-left"></i>}
                nextLabel={<i className="bi bi-chevron-double-right"></i>}
                breakLabel={"..."}
                pageCount={Math.ceil(totalRecords / params.limit)}
                marginPagesDisplayed={2}
                pageRangeDisplayed={5}
                onPageChange={(e) => handleParams(e, "pagination")}
                forcePage={params.page - 1}
                containerClassName={"pagination"}
                activeClassName={"active"}
                pageClassName={"page-item"}
                pageLinkClassName={"page-link"}
              />
            </div>
          </div>
        </section>
      </div>

      <Modal isOpen={modifyqtyModal} size="xl">
        <ModalHeader>{`Quantity`}</ModalHeader>
        <ModalBody>
          <div className="row">
            <div className="col-md-12">
              <div
                className="row"
                style={{
                  overflowX: "auto",
                  maxHeight: "300px",
                }}
              >
                <div className="card-body">
                  <div className="vehicleThBg table-responsive table-responsive-vehicle">
                    <table className="table table-bordered rounded-table table table-striped table-hover">
                      <thead>
                        <tr>
                          <th
                            className="col-form-label ml-2 Label-my form-label"
                            style={{ width: "10%" }}
                          ></th>
                          <th
                            className="col-form-label ml-2 Label-my form-label"
                            style={{ width: "10%" }}
                          >
                            Quantity
                          </th>

                          <th
                            className="col-form-label ml-2 Label-my form-label"
                            style={{ width: "10%" }}
                          >
                            Entity
                          </th>
                          <th
                            className="col-form-label ml-2 Label-my form-label"
                            style={{ width: "10%" }}
                          >
                            Price
                          </th>

                          <th
                            className="col-form-label ml-2 Label-my form-label"
                            style={{ width: "10%" }}
                          >
                            Notes
                          </th>
                        </tr>
                      </thead>
                      <tbody>
                        {partqtyDetails?.part_qty_list?.length > 0 ? (
                          partqtyDetails.part_qty_list?.map((part, index) => (
                            <tr style={{ cursor: "pointer" }} key={index}>
                              <td>
                                <input
                                  type="checkbox"
                                  className="my-checkbox-1 form-check-input"
                                  checked={selectedParts.some(
                                    (item) => item.id === part.id
                                  )}
                                  onChange={() =>
                                    handleCheckboxChange(
                                      part.parts_id,
                                      part.id,
                                      part
                                    )
                                  }
                                  style={{ marginLeft: "100px" }}
                                />
                              </td>
                              <td>{part.qty}</td>

                              <td>
                                <select
                                  className="form-select"
                                  value={
                                    selectedEntities[part.id] ||
                                    part.location_ids ||
                                    ""
                                  }
                                  onChange={(e) => handleSelectChange(e, part)}
                                >
                                  <option value="" disabled>
                                    Select
                                  </option>
                                  {renderOptions(entityList)}
                                </select>
                              </td>
                              <td>
                                <div>
                                  <label>
                                    Price 1: {partqtyDetails.vat_part_price}
                                  </label>
                                </div>

                                <div>
                                  <label>
                                    Price 2:{" "}
                                    {partqtyDetails.vat_part_original_price}
                                  </label>
                                </div>

                                <div>
                                  <label>
                                    Price 2:{" "}
                                    {partqtyDetails.vat_part_cost_price}
                                  </label>
                                </div>

                                <div>
                                  <label>
                                    Manual:
                                    <input
                                      type="number"
                                      value={selectedPrices[part.id] || ""}
                                      onChange={(e) =>
                                        handleManualInput(
                                          part.id,
                                          e.target.value
                                        )
                                      }
                                      placeholder={t("enter_manual_price")}
                                      style={{
                                        marginLeft: "10px",
                                        width: "100px",
                                      }}
                                    />
                                  </label>
                                </div>
                              </td>

                              <td>
                                <div className="input-div">
                                  <textarea
                                    className="form-control"
                                    value={
                                      resOrderData.reservation_order_notes[
                                        part.id
                                      ] || ""
                                    }
                                    onChange={(e) =>
                                      setResOrderData((prev) => ({
                                        ...prev,
                                        reservation_order_notes: {
                                          ...prev.reservation_order_notes,
                                          [part.id]: e.target.value,
                                        },
                                      }))
                                    }
                                    name={`reservation_order_notes_${part.id}`}
                                    placeholder={t("notes")}
                                    rows={3}
                                  />
                                </div>
                              </td>
                            </tr>
                          ))
                        ) : (
                          <tr>
                            <td colSpan="5" style={{ textAlign: "center" }}>
                              No data found
                            </td>
                          </tr>
                        )}
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </ModalBody>
        <ModalFooter>
          <button
            type="button"
            className="btn btn-block btn-primary"
            onClick={handleQtyClose}
            style={{ width: "100px", marginTop: "10px" }}
          >{t("close")}<i className="bi bi-x-lg"></i>
          </button>

          <button
            type="Button"
            className="btn btn-block btn-primary"
            onClick={handleQtyCloseFinal}
            style={{ width: "100px", marginTop: "10px" }}
          >{t("save")}<i className="bi bi-x-lg"></i>
          </button>
        </ModalFooter>
      </Modal>
    </div>
  );
};

export default ReservesPendingList;
